import { Box, Button, CircularProgress, Dialog, Stack, Typography } from "@mui/material";

const formatQuantity = (value) => {
  const number = Number(value);
  return Number.isFinite(number)
    ? number.toLocaleString("es-AR", { maximumFractionDigits: 10 })
    : "—";
};

export default function SalesImportRegularizationDialog({ open, shortages, loading, error, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      aria-labelledby="regularization-dialog-title"
      PaperProps={{ sx: { width: "min(92vw, 520px)", p: 3, borderRadius: "28px", bgcolor: "neutral.50" } }}
    >
      <Stack spacing={2}>
        <Typography id="regularization-dialog-title" component="h2" sx={{ fontSize: 19, fontWeight: 800, color: "primary.900" }}>
          Preparar regularizaciones
        </Typography>
        <Typography sx={{ fontSize: 14, color: "primary.900" }}>
          Se prepararán las siguientes regularizaciones.
        </Typography>
        <Stack spacing={1} sx={{ p: 1.5, border: "1px solid", borderColor: "neutral.600", borderRadius: "16px", maxHeight: 260, overflowY: "auto" }}>
          {shortages.map((item) => (
            <Stack key={`${item.itemType}-${item.itemId}`} direction="row" sx={{ justifyContent: "space-between", gap: 2 }}>
              <Typography sx={{ color: "primary.900", fontSize: 13 }}>{item.name}</Typography>
              <Typography sx={{ color: "primary.900", fontSize: 13, fontWeight: 800, whiteSpace: "nowrap" }}>
                +{formatQuantity(item.regularization)} {item.unit}
              </Typography>
            </Stack>
          ))}
        </Stack>
        <Box sx={{ p: 1.5, borderRadius: "12px", bgcolor: "secondary.100" }}>
          <Typography sx={{ color: "primary.900", fontSize: 13, fontWeight: 700 }}>
            Los movimientos se crearán recién al presionar “Integrar” en el último paso. No se modificará el Stock ahora.
          </Typography>
        </Box>
        {error ? <Typography role="alert" sx={{ color: "error.main", fontSize: 12 }}>{error}</Typography> : null}
        <Stack direction="row" spacing={1} sx={{ justifyContent: "flex-end" }}>
          <Button onClick={onClose} disabled={loading} sx={{ textTransform: "none", color: "primary.900" }}>Volver</Button>
          <Button
            onClick={onConfirm}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={15} color="inherit" /> : null}
            sx={{ px: 2, borderRadius: "33px", bgcolor: "primary.500", color: "logoblanco", textTransform: "none", fontWeight: 800, "&:hover": { bgcolor: "primary.600" } }}
          >
            Confirmar regularización
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
